/**
 * Tiny inline badge used on admin runtime-config surfaces to show
 * the cascade-resolved value next to a form field, with its source
 * tier (`doc` / `env` / `builtIn` / `unset`). Lets an operator see
 * at a glance what's currently in effect AND where it came from
 * BEFORE they edit — clearing a doc override should reveal what
 * the next tier falls through to.
 *
 * Originally a local helper in `pages/Admin/Config/index.tsx`;
 * lifted here when the Agents sub-nav split (`/admin/agents/models`,
 * `/admin/agents/budgets`) gave it three callers.
 */
import type { ReactNode } from 'react'

export interface ProvenanceProps {
  label: string
  source: 'doc' | 'env' | 'builtIn' | 'unset'
  children: ReactNode
}

export function Provenance({ label, source, children }: ProvenanceProps) {
  return (
    <p className="text-[11px] text-muted-foreground">
      <span className="font-medium">{label}:</span> <code>{children}</code>{' '}
      <span className="uppercase tracking-wider">[{source}]</span>
    </p>
  )
}
